/**
 * Microsoft 365 part 3: documents from OneDrive, SharePoint and Outlook attachments (DOC-017…): the "+" menu
 * (MsEkleMenu), the picker (MsBelgeSec), "Belgelerime kaydet" (MsMailEkKaydet) and the result card (MsDurumlar).
 * Belgeler's own words are under `documents`. Place names are the product's (Kişisel, Ekip, Çalışma alanı, Herkes).
 */
export const m365FilesTr = {
  sources: { onedrive: 'OneDrive', sharepoint: 'SharePoint', outlook: 'Outlook ekleri' },
  // the "+" menu (MsEkleMenu)
  menu: {
    computer: 'Bilgisayardan yükle',
    computerHint: 'PDF, Word, Excel, PowerPoint, görsel · en çok {{mb}} MB',
    computerHintCode: 'Kod, belge, görsel ya da arşiv · en çok {{mb}} MB',
    group: 'Microsoft 365',
    hints: {
      onedrive: 'Dosyalarım ve benimle paylaşılanlar',
      sharepoint: 'Şirketin siteleri ve belge kitaplıkları',
      outlook: 'Maillerdeki ek dosyalar',
    },
    skillHome: "Skill'ler sayfasından birini seçin",
    skillConversation: 'Bu sohbete yeni bir skill ekleyin',
    connection: 'Bağlantılar sayfasını açar',
  },
  // the picker (MsBelgeSec)
  picker: {
    title: "Microsoft 365'ten belge ekle",
    nav: 'Kaynaklar',
    sites: 'Siteler',
    allSites: 'Tüm siteler…',
    crumbs: 'Konum',
    search: {
      library: 'Bu kitaplıkta ara',
      folder: 'Bu klasörde ara',
      onedrive: "OneDrive'da ara",
      sites: 'Sitelerde ara',
      outlook: 'Eklerde ara',
    },
    results: '“{{query}}” için sonuçlar',
    clearSearch: 'Aramayı temizle',
    table: 'Dosyalar',
    columns: { name: 'Ad', by: 'Değiştiren', at: 'Değiştirilme', size: 'Boyut', from: 'Gönderen', date: 'Tarih' },
    select: 'Seç: {{name}}',
    items_one: '{{count}} öğe',
    items_other: '{{count}} öğe',
    shared: 'Paylaşılan',
    more: 'Daha fazla göster',
    note: "Yalnız Microsoft'ta görme izniniz olan dosyalar listelenir. Bir seferde en çok {{max}} dosya.",
    limit: 'En çok {{max}} dosya seçebilirsiniz; başka bir dosya için önce birini bırakın.',
    loading: 'Dosyalar yükleniyor…',
    empty: {
      folder: 'Bu klasör boş.',
      search: 'Aramanıza uyan dosya yok.',
      outlook: 'Son maillerde ek dosya yok.',
      sites: 'Takip ettiğiniz site yok. Bir siteyi adıyla arayın.',
      site: 'Bu sitede belge kitaplığı yok.',
    },
    failed: 'Burası açılamadı.',
    retry: 'Yeniden dene',
    none: 'Belge seçilmedi',
    selected_one: '{{count}} belge seçildi',
    selected_other: '{{count}} belge seçildi',
    addNone: 'Ekle',
    add_one: '{{count}} belgeyi ekle',
    add_other: '{{count}} belgeyi ekle',
    copyNote: 'Belgeler bir kez kopyalanır. Üstünde <b>Kaynak: {{source}}</b> yazar; kaynakta değişirse “Yeniden al” ile güncellenir.',
    copyNoteOutlook: 'Ekler bir kez kopyalanır. Üstünde <b>Kaynak: {{source}}</b> yazar; mail ekleri değişmez.',
  },
  // why a row cannot be picked
  blocked: {
    unsupported: 'Bu dosya türü okunamıyor',
    too_large: '{{mb}} MB sınırını aşıyor',
    malware: 'Microsoft bu dosyada zararlı yazılım buldu',
    package: 'Not defteri gibi paketler alınamaz',
    source_off: 'Buradan belge getirme kapalı',
    // the source is on, its permission not granted yet (the source's own panel has "Yeniden bağlan")
    microsoft_scopes_required: 'Yeni izin gerekiyor · yeniden bağlan',
    empty: 'Dosya boş',
  },
  // "Nereye eklensin?" / "Nereye kaydedilsin?"
  targets: {
    legend: 'Nereye eklensin?',
    legendSave: 'Nereye kaydedilsin?',
    user: 'Kişisel',
    userHint: 'Yalnız siz görürsünüz · varsayılan',
    team: 'Ekip: {{name}}',
    teamHint: 'Ekibinizdeki herkes görür',
    teamHintSave: 'Ekibinizdeki herkes görür · seçilince uyarı çıkar',
    workspace: 'Çalışma alanı: {{name}}',
    workspaceHint: 'Çalışma alanındaki herkes görür',
    organization: 'Herkes',
    organizationHint: 'Firmadaki herkes görür',
    conversation: 'Bu sohbet',
    conversationHint: 'Yalnız bu sohbette kullanılır',
    locked: 'Herkes: yalnız süper yöneticiler',
    warning: {
      team: '{{name}} ekibindeki herkes görür, {{tail}}',
      workspace: '{{name}} çalışma alanındaki herkes görür, {{tail}}',
      organization: 'Firmadaki herkes görür, {{tail}}',
    },
    tail: {
      sharepoint: "SharePoint'te bu dosyaları göremeyenler de.",
      onedrive: "OneDrive'da bu dosyaları göremeyenler de.",
      outlook: 'bu maili almayanlar da.',
      mixed: "Microsoft 365'te bu dosyaları göremeyenler de.",
    },
    acknowledge: 'Anladım',
  },
  // what the picker shows instead of the files (MsDurumlar's words where it has them)
  access: {
    connect: { title: 'Bunun için Microsoft hesabınızı bağlayın', text: 'Bağladıktan sonra dosyalarınız burada listelenir.', action: 'Hesabımı bağla' },
    reconnect: { title: 'Microsoft bağlantınızı yenilemeniz gerekiyor', text: "Microsoft hesabınız artık Oppy'ye izin vermiyor. Yeniden bağlanınca devam eder.", action: 'Yeniden bağlan' },
    consent: { title: 'Şirketinizin onayı bekleniyor', text: 'Microsoft, bu izinler için şirketinizin yöneticisinin onayını istiyor. Bilgi işlem ekibinize haber verin.' },
    scopes: {
      title: 'Yeni izin gerekiyor · yeniden bağlan',
      text: {
        onedrive: "OneDrive'daki dosyalarınızı görmek için Microsoft hesabınıza bir kez daha bağlanın; Microsoft size yeni izni soracak.",
        sharepoint: "SharePoint sitelerindeki dosyaları görmek için Microsoft hesabınıza bir kez daha bağlanın; Microsoft size yeni izni soracak.",
        outlook: 'Mail eklerini görmek için Microsoft hesabınıza bir kez daha bağlanın; Microsoft size yeni izni soracak.',
      },
      action: 'Yeniden bağlan',
    },
    off: {
      title: { onedrive: "OneDrive'dan belge getirme kapalı", sharepoint: "SharePoint'ten belge getirme kapalı", outlook: 'Mail okuma kapalı' },
      text: "Firmanız ya da ekibiniz bunu kapattı. Getirdiğiniz belgeler Belgeler'de durur.",
    },
    unavailable: { title: "Microsoft'a şu an ulaşılamıyor", text: 'Biraz sonra yeniden deneyin.', action: 'Yeniden dene' },
    returned: 'Bağlanılamadı: {{reason}}',
    device: {
      intro: "Microsoft'un sayfasında bu kodu yazın; giriş bitince dosyalarınız burada listelenir.",
      open: "Microsoft'un sayfasını aç",
      waiting: 'Girişiniz bekleniyor…',
      expired: 'Kodun süresi doldu.',
      declined: 'Giriş reddedildi.',
      again: 'Yeni kod al',
    },
    badUrl: "Microsoft'un sayfası açılamadı; yöneticinize haber verin.",
  },
  // the import's answer (MsDurumlar "Belge alınamadı"; the success line has no mockup)
  result: {
    failed_one: '{{count}} dosya alınamadı',
    failed_other: '{{count}} dosya alınamadı',
    unnamed: 'Bir dosya',
    others_one: 'Diğer {{count}} dosya eklendi.',
    others_other: 'Diğer {{count}} dosya eklendi.',
    duplicates_one: '{{count}} dosya zaten {{place}} içindeydi.',
    duplicates_other: '{{count}} dosya zaten {{place}} içindeydi.',
    added_one: '{{count}} belge eklendi · {{place}}',
    added_other: '{{count}} belge eklendi · {{place}}',
    linkedHome: 'Sohbet başlayınca bu sohbette de kullanılır.',
    linked: 'Bu sohbete de bağlandı.',
    ok: 'Tamam',
    reasons: {
      forbidden: 'bu dosyayı görme izniniz kalmamış.',
      not_found: "dosya Microsoft'ta bulunamadı; silinmiş ya da taşınmış olabilir.",
      too_large: '{{mb}} MB sınırını aşıyor.',
      unsupported: 'bu dosya türü okunamıyor.',
      malware: 'Microsoft bu dosyada zararlı yazılım buldu.',
      not_a_file: 'bu bir dosya değil.',
      empty: 'dosya boş.',
      source_off: "Microsoft 365'ten belge getirme kapalı.",
      microsoft_scopes_required: 'yeni izin gerekiyor; Microsoft hesabınıza yeniden bağlanın.',
      unavailable: "Microsoft'a şu an ulaşılamıyor; biraz sonra deneyin.",
      busy: "Microsoft'a şu an ulaşılamıyor; biraz sonra deneyin.",
    },
  },
  // "Belgelerime kaydet" on an attachment card (MsMailEkKaydet; the states after the click have no mockup)
  save: {
    button: 'Belgelerime kaydet',
    saving: 'Kaydediliyor…',
    saved: 'Kaydedildi · {{place}}',
    already: "Zaten Belgeler'de · {{place}}",
    failed: 'Kaydedilemedi: {{reason}}',
    // "Belgelerinizde üstünde **Kaynak: Outlook · Can Aydın** yazar. …": the sender's name is shown as text, never as markup
    noteLead: 'Belgelerinizde üstünde',
    noteLabel: 'Kaynak: Outlook · {{sender}}',
    noteLabelNoSender: 'Kaynak: Outlook',
    noteTail: ' yazar. Belge araması ve sohbetlerde kullanılabilir.',
    submit: 'Kaydet',
    foot: 'Ek belgelerinize kaydedildi · {{place}}',
  },
};
